// @flow
// ----------------------------------------------------------------------
// <copyright file="Izenda.NLQIsReportSavePopupActions.js" company="Izenda">
//  Copyright (c) 2015 Izenda, Inc.
//  ALL RIGHTS RESERVED
//
//  The entire contents of this file is protected by U.S. and
//  International Copyright Laws. Unauthorized reproduction,
//  reverse-engineering, and distribution of all or any portion of
//  the code contained in this file is strictly prohibited and may
//  result in severe civil and criminal penalties and will be
//  prosecuted to the maximum extent possible under the law.
//
//  RESTRICTIONS
//
//  THIS SOURCE CODE AND ALL RESULTING INTERMEDIATE FILES
//  ARE CONFIDENTIAL AND PROPRIETARY TRADE
//  SECRETS OF IZENDA INC. THE REGISTERED DEVELOPER IS
//  LICENSED TO DISTRIBUTE THE PRODUCT AND ALL ACCOMPANYING .NET
//  CONTROLS AS PART OF AN EXECUTABLE PROGRAM ONLY.
//
//  THE SOURCE CODE CONTAINED WITHIN THIS FILE AND ALL RELATED
//  FILES OR ANY PORTION OF ITS CONTENTS SHALL AT NO TIME BE
//  COPIED, TRANSFERRED, SOLD, DISTRIBUTED, OR OTHERWISE MADE
//  AVAILABLE TO OTHER INDIVIDUALS WITHOUT EXPRESS WRITTEN CONSENT
//  AND PERMISSION FROM IZENDA INC.
//
//  CONSULT THE END USER LICENSE AGREEMENT(EULA FOR INFORMATION ON
//  ADDITIONAL RESTRICTIONS.
//
// </copyright>
// ----------------------------------------------------------------------

import { compose, withHandlers } from 'recompose';
import { curry} from 'lodash/fp';
export default compose(
  withHandlers({
    onClosing: curry(onClosing),
    onAcceptClosing: curry(onAcceptClosing),
    onCancelClosing: curry(onCancelClosing),
  })
);

/**
 * On closing popup handler.
 * @param {Object} props
 * @param {Object} closeCallback
 * @param {string} type
 */
function onClosing(props: any, closeCallback: any, type: string) {
  if (type === 'accept') {
    return onAcceptClosing(props);
  } else if (type === 'cancel') {
    return onCancelClosing(props);
  }
}

/**
 * Handle when click cancel button
 */
function onCancelClosing(props: any) {
   props.onReject();
}

/**
 * When click button OK on popup
 * @param {any} props
 * @return {promise}
 */
function onAcceptClosing(props: any) {
  const {
    openSaveReportFun
  } = props;
  openSaveReportFun();
  props.onReject();
}




// WEBPACK FOOTER //
// ./ui/share/components/controls/NLQIsReportSavePopup/Izenda.NLQIsReportSavePopupActions.js